module.exports = __webpack_public_path__ + "static/media/twitter.86cdcd58.svg";